module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Bold.ad57612f.svg";